module.exports = __webpack_public_path__ + "fonts/iconfont.bc539f5.woff2";